import React from 'react'

const LoadingModal = ({ message }) => {
  return (
    <div className="fixed z-50 inset-0 overflow-y-auto">
      {/* Backdrop */}
      <div className="flex items-center justify-center min-h-screen p-4">
        <div
          className="fixed inset-0 bg-surface-900/60 backdrop-blur-sm transition-opacity"
          aria-hidden="true"
        />

        {/* Modal */}
        <div className="relative bg-white rounded-2xl shadow-soft-xl p-8 max-w-sm w-full animate-scale-in">
          {/* Spinner */}
          <div className="flex flex-col items-center gap-4">
            <div className="relative">
              {/* Outer ring */}
              <div className="w-16 h-16 rounded-full border-4 border-surface-100" />
              {/* Spinning ring */}
              <div className="absolute inset-0 w-16 h-16 rounded-full border-4 border-transparent border-t-primary-600 animate-spin" />
              {/* Inner dot */}
              <div className="absolute inset-0 flex items-center justify-center">
                <div className="w-3 h-3 rounded-full bg-primary-600 animate-pulse" />
              </div>
            </div>

            {/* Message */}
            <div className="text-center">
              <p className="text-surface-700 font-medium">{message}</p>
              <p className="text-sm text-surface-400 mt-1">This may take a moment...</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default LoadingModal
